var _circle, _circle2, _g, _circle3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrimeProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 133,
    viewBox: "0 0 119 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 69.5,
    r: 44.5,
    stroke: "#077368",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "url(#paint0_linear_453_3699)",
    stroke: "url(#paint1_linear_453_3699)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5259 47.7027H21V19H32.547C34.4716 19 36.2449 19.4124 37.867 20.2372C39.5166 21.062 40.8225 22.2304 41.7847 23.7425C42.747 25.2547 43.2281 27.0005 43.2281 28.98C43.2281 30.877 42.7332 32.6228 41.7435 34.2174C40.7812 35.812 39.4616 37.0354 37.7845 37.8877C36.3274 38.63 34.5816 39.0011 32.547 39.0011H22.5259V47.7027ZM22.5259 37.4753H32.547C34.3066 37.4753 35.75 37.2004 36.8772 36.6505C38.3343 35.9632 39.5028 34.9322 40.3825 33.5576C41.2623 32.1829 41.7022 30.6571 41.7022 28.98C41.7022 27.3304 41.2623 25.8183 40.3825 24.4436C39.5028 23.069 38.3206 22.038 36.836 21.3507C35.7088 20.8008 34.2791 20.5259 32.547 20.5259H22.5259V37.4753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0432 19.0557H47.4783V23.8185H46.0432V19.0557Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.287027
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 101,
    r: 31.5,
    fill: "url(#paint2_linear_453_3699)",
    stroke: "url(#paint3_linear_453_3699)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip1_453_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2972 106.5C92.7846 106.499 92.2786 106.383 91.8162 106.162C91.3538 105.941 90.9466 105.619 90.6243 105.22C90.3021 104.821 90.0728 104.356 89.9532 103.857C89.8336 103.359 89.8267 102.84 89.9331 102.338C90.106 101.551 90.5451 100.848 91.1763 100.347C91.8076 99.8459 92.5923 99.578 93.3981 99.5883H95.5889C95.7105 99.5883 95.827 99.54 95.913 99.4541C95.999 99.3681 96.0472 99.2516 96.0472 99.13V97.0675C96.0448 96.4605 95.8026 95.879 95.3734 95.4497C94.9441 95.0205 94.3626 94.7782 93.7556 94.7758H80.9222C80.7399 94.7758 80.565 94.7034 80.4361 94.5745C80.3072 94.4455 80.2347 94.2707 80.2347 94.0883C80.2347 93.906 80.3072 93.7311 80.4361 93.6022C80.565 93.4733 80.7399 93.4008 80.9222 93.4008H93.0681C93.1289 93.4008 93.1871 93.3767 93.2301 93.3337C93.2731 93.2907 93.2972 93.2324 93.2972 93.1717V92.9792C93.2972 91.7142 91.8581 90.6875 90.0889 90.6875H80.0056C79.5843 90.6875 79.1671 90.7705 78.7778 90.9317C78.3885 91.093 78.0349 91.3293 77.7369 91.6272C77.1353 92.2289 76.7972 93.0449 76.7972 93.8958V108.104C76.7972 108.955 77.1353 109.771 77.7369 110.373C78.0349 110.671 78.3885 110.907 78.7778 111.068C79.1671 111.23 79.5843 111.312 80.0056 111.312H93.7556C94.0565 111.312 94.3545 111.253 94.6326 111.138C94.9106 111.023 95.1632 110.854 95.376 110.641C95.5888 110.428 95.7576 110.176 95.8728 109.898C95.988 109.62 96.0472 109.322 96.0472 109.021V106.729C96.0472 106.668 96.0231 106.61 95.9801 106.567C95.9371 106.524 95.8789 106.5 95.8181 106.5H93.2972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0469 101H93.2969C92.7499 101 92.2253 101.217 91.8385 101.604C91.4517 101.991 91.2344 102.515 91.2344 103.062C91.2344 103.61 91.4517 104.134 91.8385 104.521C92.2253 104.908 92.7499 105.125 93.2969 105.125H96.0469C96.3706 105.07 96.6641 104.902 96.8742 104.649C97.0844 104.397 97.1974 104.078 97.1928 103.75V102.375C97.1974 102.047 97.0844 101.728 96.8742 101.476C96.6641 101.223 96.3706 101.055 96.0469 101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_453_3699",
    x1: 32,
    y1: 43.978,
    x2: 32,
    y2: 73.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_453_3699",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_453_3699",
    x1: 87,
    y1: 58,
    x2: 87,
    y2: 142.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052531",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_453_3699",
    x1: 87,
    y1: 69,
    x2: 87,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435F69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.55,
    height: 28.7027,
    fill: "white",
    transform: "translate(21 19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_453_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(76 90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeProgress);
export default __webpack_public_path__ + "static/media/prime-progress.42b4f04179a3ad82791d2b7975f67a6a.svg";
export { ForwardRef as ReactComponent };